import { apiFetch } from './apiFetch';
import type { HydraCollection } from '../types';

export async function apiGet<T>(endpoint: string): Promise<T> {
  const response = await apiFetch(endpoint, { method: 'GET' });
  return response as T;
}

export async function apiPost<T>(endpoint: string, body: unknown): Promise<T> {
  const response = await apiFetch(endpoint, {
    method: 'POST',
    body: JSON.stringify(body),
  });
  return response as T;
}

export async function apiPut<T>(endpoint: string, body: unknown): Promise<T> {
  const response = await apiFetch(endpoint, {
    method: 'PUT',
    body: JSON.stringify(body),
  });
  return response as T;
}

export async function apiDelete(endpoint: string): Promise<Response> {
  const response = await apiFetch(endpoint, { method: 'DELETE' }, true);
  return response as Response;
}

export function getHydraMembers<T>(collection: HydraCollection<T> | null | undefined): T[] {
  return collection?.['hydra:member'] ?? [];
}

export function getHydraTotal(collection: HydraCollection<unknown> | null | undefined): number {
  return collection?.['hydra:totalItems'] ?? 0;
}
